// extracted by mini-css-extract-plugin
export default {"stellarAgeHeader":"stellarAgeHeader__t5D5H","tagline":"tagline__C_83b","title":"title__GC2O3","titleHighlight":"titleHighlight__fE8qU","subtitle":"subtitle__l7vLR"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"stellarAgeHeader\":\"stellarAgeHeader__t5D5H\",\"tagline\":\"tagline__C_83b\",\"title\":\"title__GC2O3\",\"titleHighlight\":\"titleHighlight__fE8qU\",\"subtitle\":\"subtitle__l7vLR\"}";
        // 1787130556869
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  